import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime types.
 */

export enum SafetyNetsEnum {
  REQUIRED_TAGGING = 'required_tagging',
}

enum SafetyNetDependenciesEnum {
  TAG = 'tag',
}

export enum SafetyNetOwnersEnum {
  RULE_BUNDLE = 'ruleBundle',
}

export const RSafetyNetBase = t.type({
  type: makeEnumRuntimeType(SafetyNetsEnum),
  id: t.Integer,
  name: t.string,
  url: t.string,
  ownerId: t.number,
  ownerType: makeEnumRuntimeType(SafetyNetOwnersEnum),
  namespace: t.string,
});

export const RSafetyNetRequiredTaggingBase = t.intersection([
  RSafetyNetBase,
  t.type({
    type: t.literal(SafetyNetsEnum.REQUIRED_TAGGING),
    isOneTagRequired: t.boolean,
  }),
]);

const RSafetyNetRequiredTagging = t.intersection([
  RSafetyNetRequiredTaggingBase,
  t.type({
    dependencyType: t.literal(SafetyNetDependenciesEnum.TAG),
    dependencyIds: t.readonlyArray(t.number),
  }),
]);

const RSafetyNet = RSafetyNetRequiredTagging;

const RSafetyNets = t.readonlyArray(RSafetyNet);

/*
 * Types.
 */

export interface SafetyNetRequiredTaggingModel extends t.TypeOf<typeof RSafetyNetRequiredTagging> {}
export interface SafetyNetModel extends t.TypeOf<typeof RSafetyNet> {}

/*
 * IO methods.
 */

function parseSafetyNet(src: any): SafetyNetModel {
  switch (src.type) {
    case SafetyNetsEnum.REQUIRED_TAGGING:
      return {
        id: src.id,
        name: src.name,
        type: src.type,
        url: src.url,
        isOneTagRequired: src.settings.one_tag_required,
        ownerId: src.owner_id,
        ownerType: src.owner_type,
        dependencyType: src.dependency_type,
        dependencyIds: src.dependency_ids,
        namespace: src.namespace,
      };

    default:
      throw Error('Not implemented');
  }
}

function parseSafetyNets(src: any) {
  return src.safety_nets && src.safety_nets.map(parseSafetyNet);
}

/*
 * API types.
 */

export const ApiSafetyNets = makeApiType('safetyNetsWithDependencies', RSafetyNets, parseSafetyNets);
